<template>
  <Modal v-model="modalValue" :title="isEdit ? `编辑` : '新增'" width="800" @on-cancel="modalCancel">
    <Row style="max-height: 600px; overflow-y: auto">
      <Col span="20" offset="1">
        <Form ref="addForm" :model="form" :rules="rules" :label-width="100">
          <FormItem label="姓名" prop="name">
            <Input placeholder="请输入姓名" v-model="form.name"></Input>
          </FormItem>
          <FormItem label="创办时间" prop="found_date">
            <DatePicker
              type="year"
              v-model="form.found_date"
              placeholder="请选择创办时间"
              style="width: 100%"
            ></DatePicker>
          </FormItem>
          <FormItem label="所在地" prop="address">
            <Cascader @on-change="addressChange" :data="addressList" v-model="form.address_code"></Cascader>
          </FormItem>
          <FormItem label="详细地址" prop="address_detail">
            <Input placeholder="请输入详细地址" v-model="form.address_detail"></Input>
          </FormItem>
          <FormItem label="法人" prop="legal_person">
            <Input placeholder="请输入" v-model="form.legal_person"></Input>
          </FormItem>
          <FormItem label="法人证件号" prop="legal_card">
            <Input placeholder="请输入" v-model="form.legal_card"></Input>
          </FormItem>
          <FormItem label="法人手机" prop="legal_mobile">
            <Input placeholder="请输入" v-model="form.legal_mobile"></Input>
          </FormItem>
          <FormItem label="申请级别" prop="level">
            <Select v-model="form.level" placeholder="请选择">
              <Option
                v-for="(item, index) in mapData.levelList"
                :value="item.value"
                :label="item.text"
                :key="index"
              ></Option>
            </Select>
          </FormItem>
          <FormItem label="申请授牌名称" prop="award_name">
            <Input placeholder="请输入" v-model="form.award_name"></Input>
          </FormItem>
          <FormItem label="教练人数" prop="coach_number">
            <Input placeholder="请输入" v-model="form.coach_number"></Input>
          </FormItem>
          <FormItem label="持证裁判员/考官人数" prop="referee_number">
            <Input placeholder="请输入" v-model="form.referee_number"></Input>
          </FormItem>
          <FormItem label="开设舞种" prop="dance_type">
            <Input placeholder="请输入" v-model="form.dance_type"></Input>
          </FormItem>
          <FormItem label="校区数量" prop="campus_number">
            <Input placeholder="请输入" v-model="form.campus_number"></Input>
          </FormItem>
          <FormItem label="校区总面积" prop="campus_area">
            <Input placeholder="请输入" v-model="form.campus_area"></Input>
          </FormItem>
          <FormItem label="在校少儿学员数量" prop="sonny_number">
            <Input placeholder="请输入" v-model="form.sonny_number"></Input>
          </FormItem>
          <FormItem label="在校成人学员数量" prop="adult_number">
            <Input placeholder="请输入" v-model="form.adult_number"></Input>
          </FormItem>
          <FormItem label="有无教育、文化、体育、税务等部门惩罚记录" prop="punish_record">
            <RadioGroup v-model="form.punish_record">
              <Radio v-for="(item, index) in mapData.yesNolList" :key="index" :label="item.value">
                {{ item.text }}
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="有无教学事故及重大投诉事件" prop="complaint_record">
            <RadioGroup v-model="form.complaint_record">
              <Radio v-for="(item, index) in mapData.yesNolList" :key="index" :label="item.value">
                {{ item.text }}
              </Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="资料上传" prop="information">
            <div v-if="form.information.length > 0" class="look-img-wrap">
              <div class="look-img" v-for="(item, index) in form.information_url" :key="index">
                <img :src="item" style="width: 100%" />
                <div class="demo-upload-list-cover">
                  <Icon type="ios-eye-outline" @click.native="lookFile('information', item)"></Icon>
                  <Icon type="ios-trash-outline" @click.native="deleteFile('information', index)"></Icon>
                </div>
              </div>
            </div>
            <Upload
              v-if="form.information.length < 5"
              :action="import_url"
              :headers="headers"
              :on-error="uploadErr"
              :on-success="uploadSuccess"
              name="image"
              :show-upload-list="false"
            >
              <div class="upload-btn">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>点击或者拖拽文件上传</p>
              </div>
            </Upload>
          </FormItem>
          <FormItem label="负责与协会对接人姓名" prop="contact_name">
            <Input placeholder="请输入" v-model="form.contact_name"></Input>
          </FormItem>
          <FormItem label="负责与协会对接人电话" prop="contact_mobile">
            <Input placeholder="请输入" v-model="form.contact_mobile"></Input>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <div slot="footer">
      <Button @click="modalCancel">取消</Button>
      <Button type="primary" :loading="btnLoading" @click="modalConfirm">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import * as apiMember from '@/api/member'
  import * as mapData from '../map.js'
  import uploadFileOne from '@/components/upload-custom/upload-file-one.vue'
  import { getLoaclDate } from '@/libs/util'
  export default {
    name: 'add-card',
    components: {
      uploadFileOne,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      id: {
        type: [String, Number],
        default: '',
      },
    },
    data() {
      return {
        btnLoading: false,
        mapData, // 映射数据
        form: {
          name: '', // 营业执照全称
          found_date: '', // 创办时间
          address: [], // 地址文本
          address_code: [], // 地址编码
          address_detail: '', // 详细地址
          legal_person: '', // 法人
          legal_card: '', // 法人证件号
          legal_mobile: '', // 法人电话
          level: '', // 申请级别
          award_name: '', // 授牌名称
          coach_number: '', // 教练人数
          referee_number: '', // 持证裁判员/考官人数*
          dance_type: '', // 开设舞种
          campus_number: '', // 校区数量
          campus_area: '', // 校区总面积
          sonny_number: '', // 在校少儿学员数量
          adult_number: '', // 在校成人学员数量
          punish_record: '', // 惩罚记录
          complaint_record: '', // 投诉记录
          information: [], // 资料文件
          information_url: [], // 资料文件
          contact_name: '', // 负责与协会对接人姓名
          contact_mobile: '', // 负责与协会对接人电话
        },
        rules: {
          name: [{ required: true, message: '营业执照不能为空', triggier: 'blur' }],
          found_date: [{ required: true, type: 'date', message: '创办时间不能为空', triggier: 'change' }],
          address_code: [{ required: true, type: 'array', message: '所在地不能为空', triggier: 'change' }],
          address_detail: [{ required: true, message: '详细地址不能为空', triggier: 'blur' }],
          legal_person: [{ required: true, message: '法人不能为空', triggier: 'blur' }],
          legal_card: [{ required: true, message: '法人身份证不能为空', triggier: 'blur' }],
          legal_mobile: [{ required: true, message: '法人电话不能为空', triggier: 'blur' }],
          level: [{ required: true, type: 'number', message: '申请级别不能为空', triggier: 'blur' }],
          award_name: [{ required: true, message: '申请授牌名称不能为空', triggier: 'blur' }],
          coach_number: [{ required: true, message: '教练人数不能为空', triggier: 'blur' }],
          referee_number: [{ required: true, message: '持证裁判员/考官人数不能为空', triggier: 'blur' }],
          campus_number: [{ required: true, message: '校区数量不能为空', triggier: 'blur' }],
          campus_area: [{ required: true, message: '校区总面积不能为空', triggier: 'blur' }],
          sonny_number: [{ required: true, message: '在校少儿学员数量不能为空', triggier: 'blur' }],
          adult_number: [{ required: true, message: '在校成人学员数量不能为空', triggier: 'blur' }],
          punish_record: [
            {
              required: true,
              type: 'number',
              message: '有无教育、文化、体育、税务等部门惩罚记录不能为空',
              triggier: 'change',
            },
          ],
          complaint_record: [
            { required: true, type: 'number', message: '有无教学事故及重大投诉事件不能为空', triggier: 'change' },
          ],
          member_type: [{ required: true, type: 'number', message: '申请会员类型不能为空', triggier: 'change' }],
          information: [{ required: true, type:'array', message: '资料不能为空', triggier: 'change' }],
        },
        addressList: [],
      }
    },
    methods: {
      // 获取详情
      getDetail() {
        apiMember.apiCompanyMemberDetail(this.id).then(res => {
          const { data } = res
          this.form.name = data.name
          this.form.found_date = data.found_date
          this.form.address = data.address
          this.form.address_code = data.address_code
          this.form.address_detail = data.address_detail
          this.form.legal_person = data.legal_person
          this.form.legal_card = data.legal_card
          this.form.legal_mobile = data.legal_mobile
          this.form.level = data.level
          this.form.award_name = data.award_name
          this.form.coach_number = data.coach_number + ''
          this.form.referee_number = data.referee_number + ''
          this.form.dance_type = data.dance_type
          this.form.campus_number = data.campus_number + ''
          this.form.campus_area = data.campus_area + ''
          this.form.sonny_number = data.sonny_number + ''
          this.form.adult_number = data.adult_number + ''
          this.form.punish_record = data.punish_record
          this.form.complaint_record = data.complaint_record
          this.form.information = data.information
          this.form.information_url = data.information_url
          this.form.contact_name = data.contact_name
          this.form.contact_mobile = data.contact_mobile
        })
      },
      // 地址选择确定
      addressChange(value, selectedData) {
        this.form.address = selectedData.map(item => item.label)
      },
      // 图片上传
      imageChange(e, index) {
        if (index == 1) {
          this.form.information = e.path
          this.form.information_url = e.url
        }
      },

      // 上传成功
      uploadSuccess(res, file) {
        if (res.code == 0) {
          this.$Message.success('上传成功')
          this.form.information.push(res.data.path)
          this.form.information_url.push(res.data.url)
        } else {
          this.$Modal.error({
            title: '系统提示',
            content: res.message,
          })
        }
      },
      uploadErr() {
        if (file.status_code == 401) {
          localStorage.removeItem('token')
          return this.$router.push({
            name: 'login',
          })
        }
        this.$Modal.error({
          title: '提示',
          content: '文件上传失败，请重试',
        })
      },

      lookFile(type, item) {
        if (type == 'information') {
          window.open(item)
        }
      },
      deleteFile(type, index) {
        if (type == 'information') {
          this.form.information.splice(index, 1)
          this.form.information_url.splice(index, 1)
        }
      },

      // 提交
      modalConfirm() {
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            this.btnLoading = true
            if (this.isEdit) {
              this.form.found_date = getLoaclDate(this.form.found_date)
              apiMember.apiCompanyMemberUpdate(this.id, this.form).then(res => {
                this.$Message.success('编辑成功')
                this.$emit('on-success')
                this.modalCancel()
              }).finally(() => this.btnLoading = false)
            }
          }
        })
      },
      modalCancel() {
        this.$refs['addForm'].resetFields()
        this.$nextTick(() => {
          this.modalValue = false
        })
      },
      // 获取地址
      getRegion() {
        apiMember.apiRegionList().then(res => {
          this.addressList = res.data[0].children
        })
      },
    },
    computed: {
      modalValue: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
      import_url() {
        return process.env.VUE_APP_API_URL + '/admin/upload/image'
      },
      headers() {
        return {
          authorization: localStorage.getItem('token'),
        }
      },
    },
    watch: {
      value(val) {
        if (val && this.isEdit) {
          this.getRegion()
          this.getDetail()
        }
      },
    },
  }
</script>

<style scoped lang="less">
  .upload-btn {
    cursor: pointer;
    padding: 20px 20px;
    border-radius: 5px;
    border: 1px dashed #dcdee2;
    text-align: center;
  }
  .upload-btn:hover {
    transition: all 0.2s;
    box-shadow: 2px 2px 24px rgba(0, 0, 0, 0.1);
  }
  .look-img-wrap {
    display: flex;
    justify-content: left;
    align-items: center;
  }
  .look-img {
    margin:5px;
    display: flex;
    align-items: center;
    width: 110px;
    height: 110px;
    padding: 10px;
    border: 1px dashed rgba(197, 197, 197, 1);
    text-align: center;
    justify-content: space-evenly;
    position: relative;
  }

  .demo-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    text-align: center;
  }

  .look-img:hover .demo-upload-list-cover {
    display: block;
  }
  .demo-upload-list-cover i {
    line-height: 98px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }
</style>
